import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';

import inactivityMiddleware from './middlewares/inactivityMiddleware';
import notificationsMiddleware from './middlewares/notificationsMiddleware';
import rootReducer from './reducers';
import { mainServerAssistApi } from './services/assist';

const middleware = [
  thunkMiddleware,
  inactivityMiddleware,
  notificationsMiddleware,
  mainServerAssistApi.middleware,
].filter(Boolean);

const setupStore = (preloadedState?: any) => configureStore({
  reducer: rootReducer,
  preloadedState,
  middleware,
});

export default setupStore;
